@if (featuresReady) {
    <div>
      @if (userReady) {
      <app-topbar [title]="title" [displayName]="displayName" [email]="email"></app-topbar>
    }
    <app-menu class="menu" [routes]="routes" (collapse)="onMenuCollapseEvent($event)"
    [ngClass]="{'menu-collapsed': isMenuCollapsed, 'menu': true }"></app-menu>
    <div id="view" [ngClass]="{'menu-collapse': isMenuCollapsed, 'view': true }">
      <div class="ml-1">
        @if (showRequestsBar) {
          <app-navigation-top-bar></app-navigation-top-bar>
        }
        <!-- Global Message Banner-->
        <p-toast key="global-messages" ></p-toast>
        <router-outlet></router-outlet>
      </div>
      <!--Single Confrimation Dialog across app-->
      <p-confirmDialog key="confirmationDialog" appendTo="body"></p-confirmDialog>
      @if (showSpinner) {
        <div class="global-spinner-background">
          <p-progressSpinner [style]="{width: '150px', height: '150px'}" strokeWidth="3" class="global-spinner" ></p-progressSpinner>
          @if (showLongLoadingMessage && !isMenuCollapsed) {
            <label class="long-running-message">This operation may take a few minutes ...</label>
          }
        </div>
      }
    </div>
  </div>
}
